<template>
    <div class="container-fluid py-4">
        <h3 class="text-black">Learning Student</h3>
        <label>Let’s see your tuition student.</label>
        <br />
   
      <!-- Subscription Banner -->
      <div class="alert alert-info d-flex justify-content-between align-items-center mb-4">
        <label>
      You have subscribed to the {{ user.packageName }} package, which is valid
      until {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}} 
      {{ user.invoiceprice }} and includes a limit of
      {{ check.NumberOfStudent }} students and
      <span v-if="check.TotalTeacher === 0">Unlimited</span
      ><span v-else>{{ check.TotalTeacher }} </span> teachers.
    </label>
        <div class="badge bg-success text-white rounded-circle p-3">P</div>
      </div>
  
      <!-- Explore Box -->
      <div class="alert alert-primary d-flex align-items-center mb-4" :style="{ backgroundImage: `url(${backgroundBanner})` }">
        <i class="bi bi-bell-fill me-2"></i>
        Explore more on your student!
      </div>
  
      <!-- Actions -->
      <div class="row mb-3">
        <div class="col-md-6 d-flex align-items-center">
          <button class="btn btn-outline-secondary me-2">Click to show all including inactive student</button>
          <button class="btn btn-primary">Show All</button>
        </div>
        <div class="col-md-6 text-end">
          <input type="file" class="form-control d-inline-block w-auto me-2" />
          <button class="btn btn-primary">Upload</button>
        </div>
      </div>
  
      <!-- Filters -->
      <div class="row mb-3">
        <div class="col-md-3">
          <select class="form-select" v-model="selectedGrade">
            <option value="">All Grade</option>
            <option v-for="grade in grades" :key="grade">{{ grade }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <select class="form-select" v-model="selectedClass">
            <option value="">All Class</option>
            <option v-for="className in classes" :key="className">{{ className }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <select class="form-select" v-model="selectedStatus">
            <option value="">All Status</option>
            <option v-for="status in statuses" :key="status">{{ status }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <input class="form-control" v-model="searchQuery" placeholder="Search..." />
        </div>
      </div>
  
      <!-- Student Table -->
      <div class="table-responsive border rounded">
        <table class="table table-hover">
          <thead class="table-light">
            <tr>
              <th><input type="checkbox" /></th>
              <th>ID</th>
              <th>Student Details</th>
              <th>Package Subject</th>
              <th>Subject Class</th>
              <th>Cost</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in paginatedStudents" :key="student.id">
              <td><input type="checkbox" /></td>
              <td>{{ student.Id }}</td>
              <td class="d-flex align-items-center">
                <img
                v-if="student.profileImagePath == null"
                src="../assets/img/default.png"
                class="rounded-circle me-2" width="36" height="36" 
              />

              <img
                v-else
                :src="getPicChild(student)"
                class="rounded-circle me-2" width="36" height="36" 
              />
                <span class="ml-2">{{ student.Name }}</span>
              </td>
              <td>
                <ul class="mb-0">
                  <li v-for="pkg in student.Packages" :key="pkg">{{ pkg }}</li>
                </ul>
              </td>
              <td>
                <div v-for="subject in student.Subjects" :key="subject">
                  {{ subject }}<br />
                </div>
              </td>
              <td>
                Discount: RM {{ student.discount }}<br />
                Total Fee: RM {{ student.totalFee }}
              </td>
              <td>
                <button class="btn btn-sm btn-light">⋮</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Pagination -->
      <nav class="mt-3">
        <ul class="pagination justify-content-end">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="prevPage">Previous</button>
          </li>
          <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
            <button class="page-link" @click="goToPage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="nextPage">Next</button>
          </li>
        </ul>
      </nav>
    </div>
  </template>
  
<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import VueJsonToCsv from "vue-json-to-csv";
import VuePapaParse from "vue-papa-parse";
Vue.use(VuePapaParse);
import download from "downloadjs";
Vue.use(VuejsDialog);
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import backgroundBanner from "../assets/img/bgApps.jpg";

export default {
  data() {
    return {
      backgroundBanner,
      grades: ['Tahun 1', 'Tahun 2', 'Tahun 3'],
      classes: ['A', 'B', 'C'],
      statuses: ['Active', 'Inactive'],
      selectedGrade: '',
      selectedClass: '',
      selectedStatus: '',
      searchQuery: '',
      students: [
        {
          id: 24,
          name: 'Mohammad Ayyan Waqas',
          photo: 'https://via.placeholder.com/36',
          packages: ['Full Package'],
          subjects: ['MATEMATIK TAHUN 3', 'Teacher: GB SHAHRUL'],
          discount: 0,
          totalFee: 0,
        },
        {
          id: 25,
          name: 'Nuralya Natasha bt musa',
          photo: 'https://via.placeholder.com/36',
          packages: ['Package 1', 'Package 2'],
          subjects: ['MATEMATIK TAHUN 3', 'Teacher: GB SHAHRUL'],
          discount: 0,
          totalFee: 0,
        },
        // Add more data if needed
      ],
      currentPage: 1,
      itemsPerPage: 10,



      files: "",
      parsedCsvData: [],
      students: [],
      SearchQuery: "",
      FilteredStudents: [],

      selectedGrade: "ALL GRADE",
      gradeOptions: [],

      selectedClass: "ALL CLASS",
      classOptions: [],

      selectedStatus: "ALL STATUS",
      statusOptions: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,

      Busy: false,

      fields: [
        { key: "ID" },
        { key: "Profile" },
        { key: "StudentDetail" },
        { key: "PackageSubjects" },
        { key: "SubjectClass" },
        { key: "Cost" },
        { key: "Action" },
      ],

      fieldsResponsive: [
        { key: "ID" },
        { key: "StudentDetail" },
        { key: "Cost" },
        { key: "Action" },
      ],

      fieldsPackages: [{ key: "Name" }, { key: "Action" }],
      StudentDetailModal: false,
      studentDetails: [],

      DiscountModal: false,
      Discount: "",

      AssignPackageModal: false,
      selectedPackage: "",
      packages: [],

      studentpackages: [],
      FilteredStudentPackages: [],

      StudentModal: false,
      StudentNames: "",
      StudentEmails: "",
      ParentEmails: "",
      ParentPhoneNumbers: "",
      SelectedGradeNames: {},
      gradesName: [],
      SelectedClassNames: {},
      classes: [],

      rates: [],
      selectedRate: [],

      InactiveModal: false,

      ErrorMessage: true,
      user: {},
      small: "",
      fixed: "",
      currentDate: new Date().toISOString().substring(0, 10),

      check: {},

      SelectedStudent: "",
      SelectedStudent2: "",
      SelectedSubject: "",
      SelectedTeacher: "",
      SelectedGrades: "",

      StartTime: "",
      group: "",
      durationID: "",

      languages: [],
      sessions: [],
      times: [],
      subjects: [],
      list: [],
      grades: [],
      dur: [],

      FTModal: false,

      OneToOneForm: true,
      GroupOfTwoForm: false,
    }
  },
  components: {
    PulseLoader,
    VueJsonToCsv,
  },

  computed: {
    paginatedStudents() {
      const start = (this.currentPage - 1) * this.itemsPerPage
      return this.students.slice(start, start + this.itemsPerPage)
    },
    totalPages() {
      return Math.ceil(this.students.length / this.itemsPerPage)
    },
    FilteredStudentsList() {
      if (this.SearchQuery === "") return this.FilteredStudents;
      return this.FilteredStudents.filter((item) => {
        //teacher name
        for (const { Name } of item.Packages) {
          if (Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return item;
          }
        }

        if (
          item.Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        ) {
          return item;
        }

        if (
          item.ParentName.toLowerCase().indexOf(
            this.SearchQuery.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        if (
          item.ParentEmail.toLowerCase().indexOf(
            this.SearchQuery.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        const fee = item.Phone?.toString() || "";
        if (fee.indexOf(this.SearchQuery.toString()) > -1) {
          return item;
        }
      });
    },
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetStudent();
      //this.GetPackage();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    goToPage(page) {
      this.currentPage = page
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++
    },

    // Example style you requested
    ClosePackageUpdate() {
      this.popupupdatepackage = false
      this.popupsuccessupdatepackage = false
    },
    OpenDeleteSubjects(item) {
      const formData = new FormData()
      formData.append('Id', item.SubjectId)

      return this.$API
        .post(this.$DeleteSubjectTuitionPackage, formData, {
          withCredentials: true
        })
        .then((response) => {
          this.info = response.data
          if (response.status == 200) {
            // Success logic here
          } else {
            console.log('Error Deleting')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    async GetListChild() {
      console.log("masuk");
      this.$API
        .get(this.$AllStudentName, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },

    RefreshData() {
      this.GetStudent();
    },
    ShowAll()
    {
      this.Busy = true;
      const currentDate = new Date(); // Declare currentDate variable here
      this.$API
        .get(this.$ViewStudent + "?status=All", { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
            this.students = this.students.slice(0, this.user.totalStudent);
            this.getPicChild(this.students);
            this.FilteredStudents = this.students;
            this.Busy = false;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var classNames = _.uniq(_.map(response.data, "Class"));
            classNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.classOptions = classNames;
            this.classOptions.unshift("ALL CLASS");

            var statusNames = _.uniq(_.map(response.data, "Status"));
            statusNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.statusOptions = statusNames;
            this.statusOptions.unshift("ALL STATUS");
          }
        });
      

    }, 
    GetStudent() {
      this.Busy = true;
      const currentDate = new Date(); // Declare currentDate variable here
      this.$API
        .get(this.$ViewStudent, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
            this.students = this.students.slice(0, this.user.totalStudent);
            this.getPicChild(this.students);
            this.FilteredStudents = this.students;
            this.Busy = false;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var classNames = _.uniq(_.map(response.data, "Class"));
            classNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.classOptions = classNames;
            this.classOptions.unshift("ALL CLASS");
          }
        });
    },
    getPicChild(item) {
      return "https://pickiddo.com" + item.profileImagePath;
    },

    FilteredData() {
      console.log("masuk");
      this.FilteredStudents = this.students;

      if (this.selectedGrade !== "ALL GRADE")
        this.FilteredStudents = _.filter(
          this.FilteredStudents,
          (item) => item.Grade === this.selectedGrade
        );

      if (this.selectedClass !== "ALL CLASS")
        this.FilteredStudents = _.filter(
          this.FilteredStudents,
          (item) => item.Class === this.selectedClass
        );
        if (this.selectedStatus !== "ALL STATUS")
        this.FilteredStudents = _.filter(
          this.FilteredStudents,
          (item) => item.Status === this.selectedStatus
        );
    },
    OpenStudentModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
      this.StudentDetailModal = true;
    },
    OpenDiscountModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
      this.DiscountModal = true;
    },

    UpdateDiscount: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Discount", this.Discount);

      return this.$API
        .post(this.$UpdateDiscount, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.DiscountModal = false;
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update package ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenAssignPackageModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });

      this.$API
        .get(this.$ViewPackage, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.Busy = false;
            this.packages = response.data;
          }
        });

      this.$API
        .get(this.$GetListStudentPackage + "?manualId=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.studentpackages = response.data;
            this.FilteredStudentPackages = this.studentpackages;
          }
        });

      this.AssignPackageModal = true;
    },

    async CreateAssignPackage() {
      const formData = new FormData();

      formData.append("ManualStudentId", this.StudentId);
      formData.append("TuitionPackageId", this.selectedPackage.Id);

      return this.$API
        .post(this.$InsertAssignStudentPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            //this.Busy = false;
            //this.AssignPackageModal = false;
            //this.$dialog.alert("Success Save").then(function () {});
            this.GetPackageManualStudent(this.StudentId);
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenDeletePackages(item, Id) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteStudentPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            //   this.$dialog.alert("Details Deleted!");

            this.GetPackageManualStudent(Id);

            // this.AssignPackageModal = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    GetPackageManualStudent(Id) {
      return this.$API
        .get(this.$GetListStudentPackage + "?manualId=" + Id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            // this.Busy = false;
            this.studentpackages = response.data;
            this.GetStudent();
          }
        });
    },
    OpenStudentDirectFT(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$Languages)
        .then(
          function (response) {
            this.languages = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });

      this.$API
        .get(this.$Sessions)
        .then(
          function (response) {
            this.sessions = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });

      this.$API
        .get(this.$Times)
        .then(
          function (response) {
            this.times = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });

      this.$API
        .get(this.$Durations)
        .then(
          function (response) {
            this.dur = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });

      this.$API
        .get(this.$ViewStudent, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });

      this.$API
        .get(this.$ListTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.list = response.data;
          }
        });
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });

      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.StudentNames = this.info.Name;

            this.SetupSelectedOption();
          }
        });
      this.FTModal = true;
    },
    OpenUpdateStudent(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$ListGradeTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.gradesName = response.data;
          }
        });

      this.$API
        .get(this.$ListClassTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.classes = response.data;
          }
        });

      this.$API
        .get(this.$GetRateType, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.rates = response.data;
          }
        });

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.StudentNames = this.info.Name;
            this.StudentEmails = this.info.StudentEmail;
            this.ParentNames = this.info.ParentName;
            this.ParentEmails = this.info.ParentEmail;
            this.ParentEmailPrevious = this.info.ParentEmail;
            this.ParentPhoneNumbers = this.info.ParentPhoneNumber;
            this.Grades = this.info.Grade;
            this.ClassNames = this.info.Class;
            this.RateTypes = this.info.RateType;

            this.SetupSelectedOption();
          }
        });
      this.StudentModal = true;
    },
    SetupSelectedOption() {
      this.SelectedGradeNames = _.find(this.gradesName, {
        Name: this.Grades,
      });
      this.SelectedClassNames = _.find(this.classes, {
        Name: this.ClassNames,
      });

      this.SelectedStudent = _.find(this.students, {
        Name: this.StudentNames,
      });
    },

    UpdateStudent: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Name", this.StudentNames);
      formData.append("StudentEmail", this.StudentEmails);
      formData.append("ParentEmail", this.ParentEmails);
      formData.append("ParentEmailPrevious", this.ParentEmail);
      formData.append("ParentPhoneNumber", this.ParentPhoneNumbers);
      formData.append("Grade", this.SelectedGradeNames.Name);
      formData.append("ClassName", this.SelectedClassNames.Name);

      return this.$API
        .post(this.$UpdateManualStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.StudentModal = false;
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    DownloadSuccess() {
      console.log("Success");
    },
    DownloadFail(val) {
      console.log("Error generating CSV file.");
      console.log(val);
    },
    ConvertCsvToJson() {
      if (this.check.CurrentCountStudent >= this.check.NumberOfStudent) {
        alert("You have reached limit register student");
      } else {
        this.parsedCsvData = [];
        this.files = this.$refs.myFiles.files;

        if (this.files.length == 0) return;

        var reader = new FileReader();
        reader.onload = () => {
          var csvResult = this.$papa.parse(reader.result);
          csvResult.data.splice(0, 1);

          for (var i = 0; i < csvResult.data.length; i++) {
            var obj = {
              Name: csvResult.data[i][0],
              StudentEmail: csvResult.data[i][1],
              ParentEmail: csvResult.data[i][2],
              ParentPhoneNumber: csvResult.data[i][3],
              Grade: csvResult.data[i][4],
              ClassName: csvResult.data[i][5],
              ParentName: csvResult.data[i][6],
            };
            this.parsedCsvData.push(obj);
          }
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(this.files[0]);
      }
    },
    InsertImportStudent() {
      if (this.check.CurrentCountStudent >= this.check.NumberOfStudent) {
        alert("You have reached limit register student");
      } else {
        const formData = new FormData();

        for (var i = 0; i < this.parsedCsvData.length; i++) {
          formData.append("studentJson", JSON.stringify(this.parsedCsvData));
        }

        return this.$API
          .post(this.$InsertImportStudent, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              alert("Upload complete.");
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },

    OpenInactiveModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
      this.InactiveModal = true;
    },
    UpdateStudentStatus: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Status", "inactive");

      return this.$API
        .post(this.$UpdateStatusStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.InactiveModal = false;
            this.$dialog.alert("Success saved").then(function () {});
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GoToRenew() {
      // window.open(
      //   "https://www.pickiddo.com/RenewPackage?UserGroupId=" +
      //     this.user.usergroupId,
      //   "_blank"
      // );
      this.$router.push("/Billing");
    },
    OpenOneToOne() {
      this.OneToOneForm = true;
      this.GroupOfTwoForm = false;
    },
    OpenGroupOfTwo() {
      this.GroupOfTwoForm = true;
      this.OneToOneForm = false;
    },
    DirectOneToOne() {
      const formData = new FormData();

      formData.append("IsGroup", false);
      formData.append("StudentId", this.SelectedStudent.Id);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrades.Id);
      formData.append("DurationId", this.durationID);
      formData.append("StartTime", this.StartTime);
      formData.append("DataMessage", this.SelectedSubject.SubjectName);
      formData.append("teacherId", this.SelectedTeacher.TeacherId);

      var combinedLanguage = [];
      for (let i in this.languages) {
        let item = this.languages[i];
        combinedLanguage.push({
          LanguageId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let languageData = JSON.stringify(combinedLanguage);
      formData.append("Language", languageData);

      var combinedSession = [];
      for (let i in this.sessions) {
        let item = this.sessions[i];
        combinedSession.push({
          SessionId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let sessionData = JSON.stringify(combinedSession);
      formData.append("Session", sessionData);

      var combinedTime = [];
      for (let i in this.times) {
        let item = this.times[i];
        combinedTime.push({
          TimeId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let timeData = JSON.stringify(combinedTime);
      formData.append("Time", timeData);

      return this.$API
        .post(this.$InsertDirectFindTutorOneToOne, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
            this.$dialog.alert("Success saved find tutor").then(function () {});
            this.FTModal = false;
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    DirectGroupOfTwo() {
      const formData = new FormData();

      formData.append("IsGroup", true);
      formData.append("StudentId", this.SelectedStudent.Id);
      formData.append("studentId2", this.SelectedStudent2.Id);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrades.Id);
      formData.append("DurationId", this.durationID);
      formData.append("StartTime", this.StartTime);
      formData.append("DataMessage", this.SelectedSubject.SubjectName);
      formData.append("teacherId", this.SelectedTeacher.TeacherId);

      var combinedLanguage = [];
      for (let i in this.languages) {
        let item = this.languages[i];
        combinedLanguage.push({
          LanguageId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let languageData = JSON.stringify(combinedLanguage);
      formData.append("Language", languageData);

      var combinedSession = [];
      for (let i in this.sessions) {
        let item = this.sessions[i];
        combinedSession.push({
          SessionId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let sessionData = JSON.stringify(combinedSession);
      formData.append("Session", sessionData);

      var combinedTime = [];
      for (let i in this.times) {
        let item = this.times[i];
        combinedTime.push({
          TimeId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let timeData = JSON.stringify(combinedTime);
      formData.append("Time", timeData);

      return this.$API
        .post(this.$InsertDirectFindTutorGrouping, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
            this.$dialog.alert("Success saved find tutor").then(function () {});
            this.FTModal = false;
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  }
}
</script>
  
  <style scoped>
  .table td {
    vertical-align: middle;
  }
  </style>